import Immutable from 'immutable';
import { RawRole, Role, Roles } from 'records/Role';
import GQLRequest from 'utils/GQLRequest';

export const getRoles = async (
  projectid: string,
  licensePackage: string
): Promise<Immutable.List<Role>> => {
  const { roles } = await new GQLRequest()
    .query(
      `
      query Roles($projectid: String!, $licensePackage: String) {
        roles(projectid: $projectid, licensePackage: $licensePackage) {
          projectid
          userid
          role
          assignedRole
        }
      }
      `
    )
    .variables({ projectid, licensePackage })
    .json<{ roles: RawRole[] }>();

  return Immutable.List(roles.map(Role.deserialize));
};

export const setRole = async (
  projectid: string,
  userid: string,
  role: Roles
): Promise<Role> => {
  const { setRole: updatedRole } = await new GQLRequest()
    .query(
      `
      mutation SetRole($projectid: String!, $userid: String!, $role: String!) {
        setRole(projectid: $projectid, userid: $userid, role: $role) {
          projectid
          userid
          role
        }
      }
      `
    )
    .variables({ projectid, userid, role })
    .json<{ setRole: Role }>();

  return updatedRole;
};

export default {
  getRoles,
};
